import { useEffect, useState } from "react";

import { getOpenPurchaseOrdersByVendor } from "services/sosInventoryService/sosApi";

export function useVendorPos(vendor) {
  const [records, setRecords] = useState(null);

  useEffect(() => {
    if (vendor) {
      async function retrieveRecords() {
        const { data } = await getOpenPurchaseOrdersByVendor(vendor.id);
        setRecords(data.sort((a, b) => (a.number < b.number ? -1 : 1)));
      }
      retrieveRecords();
    }
  }, [vendor]);

  return records;
}
